import { toItem } from '../mappers/item';
export const mapItemList = (res, settings) => ({
  ...res,
  paging: {
    cursor: res.data.has_more ? res.data.cursor : null
  },
  data: (res.data.entries || []).map(item => toItem(item, settings))
});